import { useState } from 'react';
import { Button, Pagination } from 'antd';
import { Plus } from 'lucide-react';
import { TokenType } from '@/proto/agentplatform/v2/token_pb';
import { type CreateAgentTokenData } from '@/proto/agentplatform/httpv2/token_pb';
import { useAgentTokens, CreateTokenDialog, TokenRevealDialog } from '@/modules/tokens';
import TokenTable from './components/TokenTable';

export default function WebSocketTokenTab() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data, isLoading } = useAgentTokens(TokenType.WEBSOCKET, page, pageSize);

  const [createOpen, setCreateOpen] = useState(false);
  const [revealed, setRevealed] = useState<{ name: string; token: string } | null>(null);

  const list = data?.items ?? [];
  const totalCount = data?.total ?? 0;

  return (
    <>
      <div className="creds-toolbar">
        <span className="tab-desc">绑定 WS 渠道账号自动关联 Agent 实例</span>
        <div style={{ flex: 1 }} />
        <Button type="primary" icon={<Plus size={14} />} onClick={() => setCreateOpen(true)}>
          新建 WS Token
        </Button>
      </div>

      <TokenTable
        data={list}
        loading={isLoading}
        tokenType={TokenType.WEBSOCKET}
        onRegenerated={setRevealed}
      />

      {!isLoading && totalCount > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Pagination
            current={page}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger
            pageSizeOptions={[10, 20, 50, 100]}
            showTotal={(t) => `共 ${t} 条`}
            onChange={(p, ps) => {
              setPage(p);
              setPageSize(ps);
            }}
          />
        </div>
      )}

      <CreateTokenDialog
        open={createOpen}
        tokenType={TokenType.WEBSOCKET}
        onClose={() => setCreateOpen(false)}
        onCreated={(d: CreateAgentTokenData) => setRevealed({ name: d.name, token: d.token })}
      />
      <TokenRevealDialog open={!!revealed} data={revealed} onClose={() => setRevealed(null)} />
    </>
  );
}
